import { css } from 'aphrodite';
import * as React from 'react';
import { Fragment } from 'react';
import { Pill } from '../../../../web/components-v2/Pill';
import { LeadRuleViewModel } from '../../../viewModels/leadrules';
import { styleSheet } from '../styles';

interface IProps {
	leadRule: LeadRuleViewModel;
}

export const RuleTags: React.FC<IProps> = ({ leadRule }) => {
	const { and: andTags, or: orTags, not: notTags, outcomes } = leadRule.filterToArrays;
	return (
		<div className={css(styleSheet.tagContainer)}>
			{andTags.map((andTag, index, array) => {
				const showAnd = index < array.length - 1 || orTags.length > 0 || notTags.length > 0;
				return (
					<Fragment key={`${andTag}-${index}`}>
						<Pill variant='tag' color='blue' label={andTag} />
						{showAnd && <span className={css(styleSheet.separator)}>and</span>}
					</Fragment>
				);
			})}
			{orTags.map((orTag, index, array) => (
				<Fragment key={`${orTag}-${index}`}>
					<Pill variant='tag' color='blue' label={orTag} />
					{index < array.length - 1 && <span className={css(styleSheet.separator)}>or</span>}
				</Fragment>
			))}
			{notTags.map((notTag, index) => (
				<Fragment key={`${notTag}-${index}`}>
					<span className={css(styleSheet.separator)}>but not</span>
					<Pill variant='tag' color='red' label={notTag} />
				</Fragment>
			))}
			{outcomes?.length >= 1 && <div className={css(styleSheet.outcomeTypes)}>with certain outcome types</div>}
		</div>
	);
};
